/* CRUD */
const getArtefactUrl = artefactTriplet => artefactTriplet
    ? `/${artefactTriplet.id}/${artefactTriplet.agencyID}/${artefactTriplet.version}`
    : '';
export const getDsdUrl = (dsdTriplet, excludeCustom) =>
    'dsd' + (dsdTriplet ? getArtefactUrl(dsdTriplet) : '') +
    (!dsdTriplet && excludeCustom ? '/true' : '');

export const getCodelistUrl = triplet => 'codelist' + (triplet ? getArtefactUrl(triplet) : '');
export const getAgencySchemeUrl = triplet => 'agencyScheme' + (triplet ? getArtefactUrl(triplet) : '');
export const getPaginatedCodelistUrl = () => 'NOSQL/codelist';
export const getUpdateCodelistUrl = (triplet, lang) => `NOSQL/save${getArtefactUrl(triplet)}/${lang}`;
export const getCloneCodelistUrl = (srcTriplet, destTriplet) => `codelist/clone${getArtefactUrl(srcTriplet)}${getArtefactUrl(destTriplet)}`;
export const getInsertItemUrl = (triplet, lang) => `/NOSQL/insert${getArtefactUrl(triplet)}/${lang}`;
export const getUpdateItemUrl = (triplet, lang) => `/NOSQL/update${getArtefactUrl(triplet)}/${lang}`;
export const getDeleteItemUrl = (triplet, itemId, lang, autoSave) => `/NOSQL/codelist${getArtefactUrl(triplet)}/${itemId}/${lang}/${autoSave}`;
export const getMoveItemUrl = (triplet, lang) => `/NOSQL/move${getArtefactUrl(triplet)}/${lang}`;
export const getAvailableParentUrl = () => 'NOSQL/parentsAvailable';

export const getCubeUrl = (cubeId, dsdTripletStr) => 'cube' +
    (cubeId ? `/${cubeId}` : '') +
    (dsdTripletStr ? `?dsd=${encodeURIComponent(dsdTripletStr)}` : '');
export const getAllCubeUrl = (checkBackups = false) => `cubesNoFilter?checkBackups=${checkBackups}`;
export const getDcsUrl = () => 'dcs';
export const getFileMappingUrl = fileMappingId =>
    'fileMapping' + (fileMappingId ? `/${fileMappingId}` : '');
export const getFileMappingByFormatUrl = (format, pluginId) =>
    'fileMapping?mappType=' + format + (pluginId ? `&pluginId=${pluginId}` : '');
export const getUpdateFileMappingUrl = () => '/updateFileMapping';
export const getCreateSeqMappingUrl = () => '/seqMapping';
export const getSequenceMappingUrl = (sequenceMappingId = null, pluginId = null) =>
    'seqMapping' + (sequenceMappingId ? `/${sequenceMappingId}` : '') + (pluginId ? `?pluginId=${pluginId}` : '');
export const getCategorySchemeUrl = (categorySchemeTriplet, withCategorisations) =>
    'categoryScheme'
    + (categorySchemeTriplet ? getArtefactUrl(categorySchemeTriplet) : '')
    + (withCategorisations ? '/parents' : '');
export const getConceptSchemeUrl = (conceptSchemeTriplet, withCategorisations) =>
    'conceptScheme'
    + (conceptSchemeTriplet ? getArtefactUrl(conceptSchemeTriplet) : '')
    + (withCategorisations ? '/parents' : '');
export const getDdbDataflowUrl = ddbDataflowId =>
    'ddbDataflow' + (ddbDataflowId ? `/${ddbDataflowId}` : '');

export const getDdbDataflowByCudeId = ddbDataflowCubeId => '/ddbDataflowCube' + (ddbDataflowCubeId ? `/${ddbDataflowCubeId}` : '');

export const getDataflowUrl = dataflowTriplet =>
    'dataflow' + (dataflowTriplet ? getArtefactUrl(dataflowTriplet) : '');
export const getMsdUrl = msdTriplet => 'msd' + (msdTriplet ? getArtefactUrl(msdTriplet) : '');
export const getHierarchicalCodelistUrl = hierarchicalCodelistTriplet => 'getHierarchicalCodelist' + (hierarchicalCodelistTriplet ? getArtefactUrl(hierarchicalCodelistTriplet) : '');
export const getMetadataflowUrl = metadataflowTriplet =>
    'metadataflow' + (metadataflowTriplet ? getArtefactUrl(metadataflowTriplet) : '');

const getUsernameUrl = username => `${username ? `/${username}` : ''}`;

export const getAgencyUrl = username => 'getAgency' + getUsernameUrl(username);
export const getAgencyNamesUrl = () => 'AgencyName';
export const getUpdateArtefactsUrl = () => 'updateArtefacts';
export const getCreateArtefactsUrl = () => 'createArtefacts';

export const getDeleteArtefactUrl = (artefactType, artefactTriplet) =>
    'artefact/' + artefactType + getArtefactUrl(artefactTriplet);

export const getDataflowHeader = dataflowTriplet => 'getDfHeader' + getArtefactUrl(dataflowTriplet);

export const getCreateDdbDataflowUrl = () => '/createDDBDataflow';
export const getUpdateDdbDataflowUrl = () => '/updateDDBDataflow';

export const getContentConstraintUrl = triplet => `/getContentConstraint${getArtefactUrl(triplet)}`;
export const getDataflowContentConstraintUrl = artefactTriplet => "ArtefactContentConstraint/dataflow" + getArtefactUrl(artefactTriplet);

export const getArtefactReferenceUrl = (artefactType, artefactTriplet) => `artefactReference/${artefactType}${getArtefactUrl(artefactTriplet)}`;

export const getMetadataSetsUrl = () => 'api/RM/getJsonMetadatasetList';
export const getMetadataSetUrl = metadataSetId => `api/RM/getJsonMetadataset/${metadataSetId}/?excludeReport=true&withAttributes=false`;
export const getMetadataSetReportsUrl = metadataSetId => `api/RM/getJsonMetadataset/${metadataSetId}/?excludeReport=false&withAttributes=false`;
export const getMetadataSetReportUrl = (metadataSetId, reportId) => `api/RM/getJsonReport/${metadataSetId}/${reportId}`;
export const getUpsertMetadataSetUrl = () => 'api/RM/upsertJsonMetadataSet';
export const getDeleteMetadataSetUrl = metadataSetId => `api/RM/deleteGenericMetadataset/${metadataSetId}`;
export const getCloneMetadataSetUrl = (metadataSetId, newMetadataSetId) => `api/RM/cloneJsonMetadataSet/?metadatasetIdToClone=${metadataSetId}&newMetadatasetId=${newMetadataSetId}`;

export const getExportMetadataSetJsonUrl = metadataSetId => `api/RM/exportJsonMetadataset/${metadataSetId}`;

export const getExportReportJsonUrl = (metadataSetId, reportId) => `api/RM/exportJsonMetadataset/${metadataSetId}?idReport=${reportId}`;
export const getExportReportXmlUrl = (metadataSetId, reportId) => `api/RM/exportSdmxMl20Report/${metadataSetId}/${reportId}`;

export const getCheckFileJsonMetadatasetUrl = metadataSetId => `/api/RM/checkFileJsonMetadataset/${metadataSetId}`;
export const getImportFileJsonMetadatasetUrl = metadataSetId => `/api/RM/importFileJsonMetadataset/${metadataSetId}`;

export const getUpsertJsonReportUrl = metadataSetId => `api/RM/upsertJsonReport/${metadataSetId}`;
export const getDeleteReportUrl = reportDbId => `api/RM/deleteReport/${reportDbId}`;
export const getUpdateStateReportUrl = (metadataSetId, reportId) => `api/RM/updateStateMetReport/${metadataSetId}/${reportId}`;
export const getCloneReportUrl = (metadataSetId, reportId, newReportId) => `/api/RM/cloneJsonReport?metadatasetId=${metadataSetId}&reportIdToClone=${reportId}&newReportId=${newReportId}`;

export const getPaginatedDerivedCodelistUrl = isTarget => `NOSQL/preview/codelist/${isTarget}`;
export const getDerivedCodelistSelectTargetItemUrl = (artefactTriplet, isSelected, lang) =>
    `NOSQL/preview/selectedItem/${isSelected}${getArtefactUrl(artefactTriplet)}/${lang}`;
export const getDerivedCodelistSelectSourceItemUrl = (artefactTriplet, isSelected, lang) =>
    `NOSQL/selectedItem/${isSelected}${getArtefactUrl(artefactTriplet)}/${lang}`;
export const getDerivedCodelistSelectAllItemsUrl = (artefactTriplet, isTarget, isSelected, lang) =>
    `NOSQL/selectAllItem/${isTarget}/${isSelected}${getArtefactUrl(artefactTriplet)}/${lang}`;
export const getDerivedCodelistStoreSelectedItemsUrl =
    (artefactTriplet, isTarget, lang, removeParent, parents, children, descendants) =>
        `NOSQL/preview/storeSelectedItem/${isTarget}${getArtefactUrl(artefactTriplet)}/${lang}/${parents}/${children}/${descendants}/${removeParent}`;
export const getDerivedCodelistCreateUrl = (artefactTriplet, lang) => `NOSQL/save/preview${getArtefactUrl(artefactTriplet)}/${lang}`;
export const getDerivedCodelistRestoreDbUrl = artefactTriplet => 'NOSQL/previewEmpty' + getArtefactUrl(artefactTriplet);
export const getDerivedCodelistIsSourceItemValidUrl = (artefactTriplet, lang) => `NOSQL/previewIsValid${getArtefactUrl(artefactTriplet)}/${lang}`;
export const getSetDefaultOrderUrl = (artefactTriplet, lang) => `NOSQL/copyorder${getArtefactUrl(artefactTriplet)}/${lang}`;

export const getUpdateMsdUrl = () => "msd";
export const getUpdateHierarchicalCodelistUrl = () => "updateHierarchicalCodelist";

export const getSeriesForCubeUrl = cubeId => `/SeriesForCube/${cubeId}`;
export const getDeleteSeriesForCubeUrl = cubeId => `RemoveSeriesForCube/${cubeId}`;

export const getDeleteRecordsForCubeUrl = (cubeId) => `RemoveRecordsForCube/${cubeId}`;
export const getUpdateObsValueForCubeUrl = (cubeId, obsValue) => `UpdateRecordForCube/${cubeId}?obsValue=${encodeURIComponent(obsValue)}`

export const getCubeBackupURL = (cubeId) => `cube/CreateBackup/${cubeId}`
export const getCubeRestoreURL = (cubeId) => `cube/RestoreBackup/${cubeId}`
export const deleteCubeBackupURL = (cubeId) => `cube/DeleteBackup/${cubeId}`
export const deleteFilteredDataSetURL = () => `deleteFilteredDataset`
export const getEncodeableArtefacts = (dfId) => `GetEncodeableArtefacts/${dfId}`


/* UTILITY */
export const getUploadFileOnServerUrl = (cubeId = null, pluginId = null, type = null) => `uploadFileOnServer${cubeId ? `/${cubeId}` : ''}${pluginId ? `?pluginId=${pluginId}` : ""}${type ? `${!!pluginId ? "&" : "?"}type=${type}` : ""}`;
export const getImportCalculatedRules = (tableName) => `importCalculatedRules/${tableName}`;
export const getCreateTempTableUrl = (filePath, separator, delimiter, mode = null) => `createTempTable/?filePath=${encodeURIComponent(filePath)}&separator=${encodeURIComponent(separator)}&delimiter=${delimiter == null ? `` : encodeURIComponent(delimiter)}${mode ? `&mode=${mode}` : ''}`;
export const getCsvHeaderUrl = (separator, delimiter, hasHeader, filePath, mode = null) =>
`getCSVHeader/${encodeURIComponent(separator)}/${hasHeader}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}?filePath=${encodeURIComponent(filePath)}${mode ? `&mode=${mode}` : ''}`;
export const getCalcFieldUrl = (tableName) => `getCalcField/${tableName}`;
export const getTablePreviewDownload = (tableName, separator, delimiter, compression) => `getTablePreviewDownload/${tableName}/${compression}?separator=${separator == null ? `;` : separator}&delimiter=${delimiter == null ? `` : delimiter}`;

export const getCsvTablePreviewUrl = (separator, delimiter, hasHeader, filePath, tid, idMappingSpecialTimePeriod, mode = null) =>
    `getCSVTablePreview/${encodeURIComponent(separator)}/${hasHeader}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}?filePath=${encodeURIComponent(filePath)}`
    + (tid !== null ? `&tid=${encodeURIComponent(tid)}` : '') + (idMappingSpecialTimePeriod !== null ? `&idMappingSpecialTimePeriod=${encodeURIComponent(idMappingSpecialTimePeriod)}` : '') + (mode ? `&mode=${mode}` : '');

export const getTempTablePreviewUrl = (tableName) => `getTablePreview/${tableName}`;
export const getDeleteCalcFieldUrl = (tableName) => `deleteCalcField/${tableName}`;
export const getCreateCalcFieldUrl = (tableName) => `createCalcField/${tableName}`;
export const getEditCalcFieldUrl = (tableName, fieldName) => `editCalcField/${tableName}/${fieldName}`; 
export const getDeleteTempTableUrl = (tableName) => `deleteTempTable/${tableName}`;
export const getCalcFieldDetailUrl = (tableName, fieldName) => `getCalcFieldDetail/${tableName}/${fieldName}`;
export const getCalculatedRulesDownloadUrl = (tableName) => `getCalculatedRulesDownload/${tableName}`;

export const getEditCsvFieldUrl = (tableName, fieldName, newFieldName) => `editCsvField/${tableName}/${fieldName}?newFieldName=${newFieldName}`; 

export const getCsvTableColumnPreviewUrl = (separator, delimiter, hasHeader, filePath, mode = null) =>
    `getCSVTableColumnPreview/${encodeURIComponent(separator)}/${hasHeader}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}?filePath=${encodeURIComponent(filePath)}${mode ? `&mode=${mode}` : ''}`;

export const getCalcTableColumnPreviewUrl = (tableName) => `getCalculatedTableColumnPreview/${tableName}`;

export const getImportCsvUrl = (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccTriplet, mode = null, deleteMode = false) =>
    `importCSVData/${encodeURIComponent(separator)}/${hasHeader}/${importType}/${cubeId}/${mappingId}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (idMappingSpecialTimePeriod !== null ? `&idMappingSpecialTimePeriod=${encodeURIComponent(idMappingSpecialTimePeriod)}` : '') +
    (embargo === true ? `&embargo=true` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (ccTriplet ? `&ccCode=${encodeURIComponent(ccTriplet)}` : '') +
    (mode ? `&mode=${mode}` : '') +
    (deleteMode ? `&deleteMode=${deleteMode}` : '')
    ;

export const getImportFieldExpressionCsvUrl = (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccTriplet, mode = null, deleteMode = false, ccFile = null) =>
    `importCSVDataFieldExpression/${encodeURIComponent(separator)}/${hasHeader}/${importType}/${cubeId}/${mappingId}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (idMappingSpecialTimePeriod !== null ? `&idMappingSpecialTimePeriod=${encodeURIComponent(idMappingSpecialTimePeriod)}` : '') +
    (embargo === true ? `&embargo=true` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (ccTriplet ? `&ccCode=${encodeURIComponent(ccTriplet)}` : '') +
    (mode ? `&mode=${mode}` : '') +
    (deleteMode ? `&deleteMode=${deleteMode}` : '') +
    (ccFile ? `&ccFile=${encodeURIComponent(ccFile)}` : '') 
    ;

export const getImportCsvWithValidationUrl = (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccFilePath, mode = null, deleteMode = false) =>
    `importCSVDataWithFileValidation/${encodeURIComponent(separator)}/${hasHeader}/${importType}/${cubeId}/${mappingId}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (idMappingSpecialTimePeriod !== null ? `&idMappingSpecialTimePeriod=${encodeURIComponent(idMappingSpecialTimePeriod)}` : '') +
    (embargo === true ? `&embargo=true` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (ccFilePath ? `&ccFile=${encodeURIComponent(ccFilePath)}` : '') +
    (mode ? `&mode=${mode}` : '');

export const getImportExcelWithSeqMappingUrl = (importType, seqMappingId, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccTriplet, pluginUid = "") =>
    `importExcelWithSeqMapping/${importType}/${seqMappingId}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (embargo === true ? `&embargo=true` : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ccTriplet ? `&ccCode=${encodeURIComponent(ccTriplet)}` : '') +
    (pluginUid ? `&pluginId=${pluginUid}` : '');

export const getImportExcelWithSeqMappingWithValidationUrl = (importType, seqMappingId, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccFilePath, pluginUid = "") =>
    `importExcelWithSeqMappingAndFileValidation/${importType}/${seqMappingId}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (embargo === true ? `&embargo=true` : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ccFilePath ? `&ccFile=${encodeURIComponent(ccFilePath)}` : '') +
    (pluginUid ? `&pluginId=${pluginUid}` : '');

export const getAttributeFileUrl = (separator, delimiter, hasHeader, cubeId, filePath, tid, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, deleteMode) =>
    `importAttributeFile/${encodeURIComponent(separator)}/${hasHeader}/${cubeId}${delimiter !== null ? `/${encodeURIComponent(delimiter)}` : ''}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid != null ? `&tid=${encodeURIComponent(tid)}` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (deleteMode === true ? '&deleteMode=true' : '');

export const getTablePreviewUrl = (tableName) =>
    `getTablePreview/${encodeURIComponent(tableName)}`;

export const getSdmxMlTablePreviewUrl = (dsdId, dsdAgencyId, dsdVersion, filePath) =>
    `getSDMXMLTablePreview/${dsdId}/${dsdAgencyId}/${dsdVersion}?filePath=${encodeURIComponent(filePath)}`;

export const getImportSdmxMlUrl = (importType, cubeId, dsdId, dsdAgencyId, dsdVersion, filePath, tid, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccTriplet) =>
    `importSDMXMLData/${importType}/${cubeId}/${dsdId}/${dsdAgencyId}/${dsdVersion}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid !== null ? `&tid=${tid}` : '') +
    (embargo === true ? `&embargo=true` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (ccTriplet ? `&ccCode=${encodeURIComponent(ccTriplet)}` : '');

export const getImportSdmxMlWithValidationUrl = (importType, cubeId, dsdId, dsdAgencyId, dsdVersion, filePath, tid, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccFilePath) =>
    `importSDMXMLDataWithFileValidation/${importType}/${cubeId}/${dsdId}/${dsdAgencyId}/${dsdVersion}` +
    `?filePath=${encodeURIComponent(filePath)}` +
    (tid !== null ? `&tid=${tid}` : '') +
    (embargo === true ? `&embargo=true` : '') +
    (refreshProdDf === true ? '&refreshProdDf=true' : '') +
    (checkFiltAttributes === true ? '&checkFiltAttributes=true' : '') +
    (ignoreConcurrentUpload === true ? '&ignoreCuncurrentUpload=true' : '') +
    (ccFilePath ? `&ccFile=${encodeURIComponent(ccFilePath)}` : '');

export const getImportDCSUrl = (id, agencyId, version) => `importDCS/${id}/${agencyId}/${version}`;

export const getDataflowPreviewUrl = checkFilter =>
    `getDDBDataflowPreview/${checkFilter ? "true" : ""}`;

export const getDataflowColumnPreviewUrl = (colName, pageNum, pageSize) =>
    `getDataflowColumnPreview/${colName}/${pageNum}/${pageSize}`;

export const getDataflowMappingHandlerColumnPreviewUrl= (colName, pageNum, pageSize) =>
`getDataflowMappingHandlerColumnPreview/${colName}/${pageNum}/${pageSize}`;

export const getDataflowCsvUrl = (separator, delimiter, compression) =>
    `getDDBDataflowCsv/${compression}?separator=${encodeURIComponent(separator)}${delimiter ? `&delimiter=${encodeURIComponent(delimiter)}` : ''}`;

export const getDownloadArtefactUrl =
    (artefactType, artefactTriplet, format, references, compression, lang, separator, delimiter) =>
        `downloadMetadati/${artefactType}${getArtefactUrl(artefactTriplet)}/${format}/${references}/${compression}/${lang}` +
        `${separator ? `/${separator}` : ''}${delimiter ? `/${delimiter}` : ''}`;
export const getMultipleDownloadArtefactUrl = (artefactType, format, references, compression, lang) =>
    `downloadMetadati/${artefactType}/${format}/${references}/${compression}/${lang}`;

export const getDownloadMetadatiList = (compressed, separator, delimiter, type, lang) => `downloadMetadatiList/${compressed}/${separator}/${type}/${lang}${delimiter ? `/${delimiter}` : ''}`;

export const getDownloadDdbdataflowUrl = (format, compression, separator, delimiter, dimension) =>
    `/downloadDataflow/${format}/${compression}${separator ? `/${separator}` : ''}${delimiter ? `/${delimiter}` : ''}` +
    (dimension ? `?observation=${dimension}` : '');

export const getExportArtefactUrl = () => "DuplicateArtefact";

export const getCheckImportedFileXmlSdmxObjectsUrl = () => 'checkImportedFileXmlSdmxObjects';
export const getImportFileXmlSdmxObjectsUrl = () => 'importFileXmlSdmxObjects';

export const getImportFileXmlSdmxObjects20Url = () => 'importFileXmlSdmxObjects20';

export const getCreateDataflowMappingSetUrl =
    (ddbDataflowId, defaultValue) =>
        `CreateMappingSetForDataflow/${ddbDataflowId}${defaultValue ? `/${encodeURIComponent(defaultValue)}` : ''}`;
export const getRemoveDataflowMappingSetUrl =
    (ddbDataflowId, check) => `RemoveMappingSetForDataflow/${ddbDataflowId}?check=${check}`;
export const getCreateDataflowTranscodingUrl =
    (ddbDataflowId, checkTimeFormat) => `CreateTranscodingsForDataflow/${ddbDataflowId}/${checkTimeFormat}`;
export const getCreateDataflowTranscodingFromCCUrl = (ddbDataflowId, contentConstraintTriplet, checkTimeFormat) =>
    `CreateTranscodingsFromCCForDataflow/${ddbDataflowId}/${contentConstraintTriplet.agencyID}/${contentConstraintTriplet.id}/${contentConstraintTriplet.version}/${checkTimeFormat}`;
export const getRemoveDataflowTranscodingUrl = ddbDataflowId =>
    `RemoveTranscodingsForDataflow/${ddbDataflowId}`;
export const getCreateDataflowContentConstraintUrl =
    (ddbDataflowId, isAllowed) => `CreateContentConstraintsForDataflow/${ddbDataflowId}/${isAllowed}`;
export const getRemoveDataflowContentConstraintUrl =
    ddbDataflowId => `RemoveContentConstraintsForDataflow/${ddbDataflowId}`;
export const getSetDataflowProductionFlagUrl =
    (ddbDataflowId, isProduction, check) => `SetDataflowProductionFlag/${ddbDataflowId}/${isProduction}?check=${check}`;

export const getMappingSetIdUrl =
    ddbDataflowId => `GetMappingSetIdForDDBDataflow/${ddbDataflowId}`;

export const getCheckImportedFileCsvItemUrl = () => 'checkImportedFileCsvItem';
export const getImportFileCsvItemUrl = () => 'importFileCsvItem';

export const getShyncCodelistsUrl = () => 'syncCodelist';
export const getAllCodelistToBeSynchronizedUrl = () => 'getAllCodelistToBeSynchronized';

export const getDsdWithDataflowUrl = () => 'getDSDWithDataflow';
export const getAllUpgradableDsdUrl = dsdTriplet => 'getAllUpgradableDSD' + getArtefactUrl(dsdTriplet);
export const getUpgradeDsdUrl = () => 'upgradeDSD';

export const getGenerateReportDsdUrl = (sourceDsdTriplet, targetDsdTriplet, checkIfIsUpgradable) =>
    'generateReportDSD' + getArtefactUrl(sourceDsdTriplet) + getArtefactUrl(targetDsdTriplet) + (checkIfIsUpgradable ? '/true' : '/false');
export const getCompareDsdsUrl = callCompare => `compareDSD/${callCompare ? "true" : "false"}`;
export const getGenerateFileReportDsdUrl = lang => 'generateFileReportDSD/' + lang;

export const getCompareCodelistUrl = (sourceCodelistTriplet, targetCodelistTriplet, sourceDsdFile, targetDsdFile) =>
    ((sourceDsdFile || targetDsdFile) ? "CompareCodelistMix" : "CompareCodelist") +
    getArtefactUrl(sourceCodelistTriplet) +
    getArtefactUrl(targetCodelistTriplet) +
    ((sourceDsdFile || targetDsdFile)
            ? `?sourceFile=${encodeURIComponent(sourceDsdFile || "NULL")}&targetFile=${encodeURIComponent(targetDsdFile || "NULL")}`
            : ""
    );

export const getCompareItemsUrl = (artefactType, sourceTriplet, targetTriplet) =>
    `compareItem/${artefactType}` +
    `?first=${sourceTriplet ? encodeURIComponent(`${sourceTriplet.id}+${sourceTriplet.agencyID}+${sourceTriplet.version}`) : ''}` +
    `&second=${targetTriplet ? encodeURIComponent(`${targetTriplet.id}+${targetTriplet.agencyID}+${targetTriplet.version}`) : ''}`;

export const getCompareItemsForFileUrl = (artefactType, lang, sourceTriplet, targetTriplet) =>
    `compareItemForFile/${artefactType}/${lang}` +
    `?first=${sourceTriplet ? encodeURIComponent(`${sourceTriplet.id}+${sourceTriplet.agencyID}+${sourceTriplet.version}`) : ''}` +
    `&second=${targetTriplet ? encodeURIComponent(`${targetTriplet.id}+${targetTriplet.agencyID}+${targetTriplet.version}`) : ''}`;

export const getMergeArtefactsUrl = (artefactType, sourceTriplet, targetTriplet) =>
    `mergeArtefact/${artefactType}` +
    `?first=${sourceTriplet ? encodeURIComponent(`${sourceTriplet.id}+${sourceTriplet.agencyID}+${sourceTriplet.version}`) : ''}` +
    `&second=${targetTriplet ? encodeURIComponent(`${targetTriplet.id}+${targetTriplet.agencyID}+${targetTriplet.version}`) : ''}`;

export const getMergeCodelistsUrl = (sourceTriplet, targetTriplet) =>
    `mergeCodelist/codelist` +
    `?first=${sourceTriplet ? encodeURIComponent(`${sourceTriplet.id}+${sourceTriplet.agencyID}+${sourceTriplet.version}`) : ''}` +
    `&second=${targetTriplet ? encodeURIComponent(`${targetTriplet.id}+${targetTriplet.agencyID}+${targetTriplet.version}`) : ''}`;
export const getMergedCodelistPageUrl = () => "NOSQL/searchmerge/codelist";
export const getSaveMergedCodelistUrl = lang => `saveMergeCodelist/${lang}`;

export const getXmlArtefactPreviewUrl = artefactType => `previewArtefact/${artefactType}`;
export const getXmlCodelistPreviewUrl = lang => `previewCodelist/${lang}`;

export const getUploadRMFileOnServerUrl = () => 'uploadReferenceMetadataFileOnServer';
export const getDownloadRMFileOnServerUrl = fileName => `referenceMetadataFileOnServer?filename=${encodeURIComponent(fileName)}`;

export const getCreateDCSCategoryUrl = () => "InsertDCS";
export const getEditDCSCategoryUrl = () => "UpdateDCS";
export const getDeleteDCSCategoryUrl = catCode => `DeleteDCS/${catCode}`;

export const getCloneMsdUrl = (srcTriplet, destTriplet) => `msd/clone${getArtefactUrl(srcTriplet)}${getArtefactUrl(destTriplet)}`;
export const getCloneHclUrl = (srcTriplet, destTriplet) => `hcl/clone${getArtefactUrl(srcTriplet)}${getArtefactUrl(destTriplet)}`;

export const getConfiguredPluginsURL = (nodeId, pluginType) => {
    return `GetConfiguredPlugin/${nodeId}/${pluginType}`
}

export const getCcForCube = cubeId => `ccForCube/${cubeId}`;

export const getGenerateCCFromFileUrl = (triplet, filePath, separator, delimiter) =>
    `generateCCFromFile/${encodeURIComponent(separator)}${getArtefactUrl(triplet)}${delimiter ? `/${encodeURIComponent(delimiter)}` : ""}?filePath=${encodeURIComponent(filePath)}`;

export const CONFIG_TYPE_APP = 'app';
export const CONFIG_TYPE_NODES = 'nodes';
export const CONFIG_TYPE_NODES_DEFAULT = 'nodes-default';
export const CONVERT_FILE_STAND_ALONE_URL = 'convert';
export const DOWNLOAD_TRANSFORMED_FILE_URL = 'downloadTransformedFile';
export const getConfigUrl = configType => `configuration/${configType}`;
export const getAppConfigUrl = () => 'appConfig';
export const getNodePingUrl = () => 'ping';
export const getSaveConfigNodeUrl = (username, password) => 'Config/SaveNode/' + username + (password ? `/${encodeURIComponent(password)}` : '');
export const getDeleteConfigNodeUrl = nodeId => `/Config/DeleteNode/${nodeId}`;
export const getSortNodesUrl = () => 'Config/SortConfiguration';
export const getCheckEndpointNSIUrl = () => "Config/CheckEndPointNSI";
export const getCheckEndpointMAUrl = () => "Config/CheckEndPointMA";
export const getCheckEndpointDMUrl = () => "Config/CheckEndPointDM";
export const getCheckAgencyAssignedToAnyUserUrl = (agencyCode, nodeCode) => `IsAgencyAssignToAnyUser/${agencyCode}/${nodeCode}`;

/* AUTHENTICATION */
export const getLoginUrl = () => 'api/Security/Authenticate';
export const getLogoutUrl = () => 'api/Security/Logout';
export const getSuperUserLoginUrl = () => '/api/Security/LoginSuperUser';
export const getSuperUserLogoutUrl = () => '/api/Security/LogoutSuperUser';
export const getRecoverPasswordUrl = () => '/api/Security/RecoveryPassword';
export const getUpdateUserUrl = () => '/Config/UpdateUser';

/* PERMISSIONS */
export const getUsers = () => 'GetUsers';
export const getReadPermissionsUrl = username => `GetData${username ? `/${encodeURIComponent(username)}` : ''}`;
export const getAllAgenciesUrl = () => 'GetAllAgency';
export const getAllFunctionalitiesUrl = () => 'GetFunctionalityHierarchy';

export const getAllDbbConnectionsUrl  = () => 'GetAllDdbConnections';
export const getAllRulesUrl = () => 'GetAllRules';
export const getSubmitPermissionsUrl = () => 'AssignsAll';
export const getSynchronizeAuthDBUrl = () => 'SynchronizeAuthDB';
export const getCreateUserUrl = () => '/Config/CreateUser';
export const getDeleteUserUrl = username => `Config/DeleteUser/${username}`;

export const getCubeOwnersUrl = cubeId =>
    `GetOwners/Cube?id=${encodeURIComponent(cubeId)}`;
export const getDataflowOwnersUrl = dataflowTripletStr =>
    `GetOwners/Dataflow?id=${encodeURIComponent(dataflowTripletStr)}`;
export const getMetadataflowOwnersUrl = metadataflowTripletStr =>
    `GetOwners/MetadataFlow?id=${encodeURIComponent(metadataflowTripletStr)}`;
export const getSetOwnersUrl = () => "SetOwners";

/* UTILS */
export const getRemoveTempTablesUrl = () => 'Utils/RemoveTempTable';

export const getDisembargoCubeUrl = cubeId => `DisembargoCube/${cubeId}`;

export const getEmptyCubeUrl = cubeId => `EmptyCube/${cubeId}`;

export const getDdbResetUrl = () => "DDBReset";

export const getAddAgencyToConfigUrl = nodeId => `AddAgencyToConfig/${nodeId}`;

export const getRefreshLastUpdateAnnotations = (cubeId) =>
    `RefreshLastUpdateAnnotations/${cubeId}`;

export const getIcons = () => 'GetIcons';
export const getColors  = () => 'GetColors';

/* DATA BROWSER */
export const getDataBrowserClearAllCacheUrl = () => "DataBrowserGenerateCatalogCache";
export const getDataBrowserClearCacheUrl = (id, agencyId, version) => `DataBrowserClearItemCache/${id}/${agencyId}/${version}`;
export const getDataBrowserClearDsdCacheUrl = () => "DataBrowserClearDSDCache";

/* MAPPING HANDLER */
export const getDatasetsUrl = (connId, username) => `GetDatasets?connectionId=${connId}&username=${username}`;
export const getDatasetUrl = (datasetId) => `GetDataset/${datasetId}`;
export const deleteDatasetUrl = (datasetId) => `RemoveDataset/${datasetId}`;
export const saveDatasetUrl = () => `SaveDataset`;
export const getDatasetTableView = (connId) => `GetTableView?idConnection=${connId}`;

export const getDdbConnectionsUrl = () => 'GetDdbConnections';
export const getDatasetsForAllConnections = () => 'GetDatasetsForAllConnections';
export const getSaveConnection = () => 'SaveConnection';
export const getTestConnection = () => 'TestConnection';
export const getRemoveConnection = () => 'RemoveConnection';
export const getRemoveConnections = () => 'RemoveConnections';
export const getMdmConnectionUrl = () => 'GetMdmConnections';
export const getTableViewColumnsDataPreviewUrl = (connId, tableName) => `GetTableViewColumn?idConnection=${connId}&tableName=${encodeURIComponent(tableName)}`;
export const getTableViewDataPreviewUrl = () => `GetTableViewData`;
export const getDatasetPreviewUrl = () => `GetDatasetPreview`;
export const updateInDBDatasetBuilderUrl = () => `UpdateInDb`;
export const getConnectionDatacubesAndDataflows = (connId) => `GetDataCubeDataFlow/${connId}`;

export const getMappingSetsUrl = () => 'GetMappingSets'
export const getMappingSetUrl = (mappingId) => `GetMappingSet/${mappingId}`
export const saveMappingSetUrl = () => 'SaveMappingSet';
export const deleteMappingSetUrl = (mappingSetId) => `DeleteMappingSet/${mappingSetId}`;
export const getMappingSetPreviewTokenUrl = () => `LoadMappedData`;
export const getMappingSetPreviewRemoveTempTableUrl = () => `RemoveMappedDataTempTable`;
export const getMappingSetPreviewDataUrl = (token) => `GetMappedData?token=${token}`;
export const getDataFromDatasetUrl = (entityId) => `GetDataFromDataset?idDataset=${entityId}`;
export const getDataFromCodeListUrl = (agencyID, codelistId, version) => `GetDataFromCodelist?agencyID=${agencyID}&codelistId=${codelistId}&version=${version}`;
export const getTranscodingCodeMatch = (agencyID, codelistId, version, columnName) => `TranscodingCodeMatch?agency=${agencyID}&id=${codelistId}&version=${version}&columnName=${columnName}`;
export const getTranscodingUrl = (mappingId, isTimeTranscoding) => `GetTranscoding/${mappingId}/${isTimeTranscoding}`
export const getDataflowBuilderDatasetPrefixUrl = () => 'GetDataflowBuilderDatasetPrefix';
export const submitTranscoding01Url = () => `TranscodingZeroUno`;
export const deleteMappingUrl = (mappingId, isTimeMapping) => `DeleteMapping/${mappingId}/${isTimeMapping}`;
export const getTranscodignUrl = (mappingComponentId) => `GetTranscoding/${mappingComponentId}`;
export const getDataflowPublishingDataflowsUrl = () => 'GetDataflowForMappingHandler';
export const getCreateDataflowPublishingContentConstraintUrl =
    (dataflowTriplet, isAllowed) => `CreateContentConstraintsForDataflowMappingHandler/${dataflowTriplet.id}/${dataflowTriplet.agencyID}/${dataflowTriplet.version}/${isAllowed}`;
export const getRemoveDataflowPublishingContentConstraintUrl =
    dataflowTriplet => `RemoveContentConstraintsForDataflowMappingHandler/${dataflowTriplet.id}/${dataflowTriplet.agencyID}/${dataflowTriplet.version}`;
export const getSetDataflowPublishingProductionFlagUrl =
    (dataflowTriplet, isProduction) => `SetDataflowProductionFlagMappingHandler/${dataflowTriplet.id}/${dataflowTriplet.agencyID}/${dataflowTriplet.version}/${isProduction}`;
export const submitTranscodingTimeDimensionUrl = () => `SaveTimeTranscoding`
export const saveDimensionTranscodingUrl = () => `SaveTranscoding`
export const deleteDimensionTranscodingUrl = (transcodingEntityId, isTimeTranscoding) => `DeleteTranscoding/${transcodingEntityId}?isTimeMapping=${isTimeTranscoding}`
export const getStruvalInformationUrl = () => `GetStruvalInformation`
export const validateMappingSetFormatUrl = () => 'FormatValidation';
export const validateMappingSetMappingUrl = () => 'MappingValidation';
export const validateMappingSetDataUrl = () => 'DataValidation';
export const validateMappingSetDatasetUrl = () => 'DatasetValidation';
export const getDataflowPublishingInfoUrl = (dataflowTriplet) => `GetDataFlowInfo/${dataflowTriplet.id}/${dataflowTriplet.agencyID}/${dataflowTriplet.version}`
export const getDataflowHeaderUpdateUrl = (dataflowTriplet) => `UpdateHeaderTemplate/${dataflowTriplet.id}/${dataflowTriplet.agencyID}/${dataflowTriplet.version.split(".").join("/")}`;
export const downloadDataflowForMappingHandlerUrl = (format, zipped = false, separator = null, delimiter = null) => `downloadDataflowForMappingHandler/${format}/${zipped}/${separator ? `${encodeURIComponent(separator)}/` : ""}${delimiter ? `${encodeURIComponent(delimiter)}/` : ""}`

export const getDistinctTempTableFieldURL = (tableName) => `getDistinctTempTableField/${tableName}`
export const getImportCaseFunctionURL = (separator,delimiter,hasHeader,filePath,fieldName)=> `importCaseFunction?separator=${encodeURIComponent(separator)}&delimiter=${delimiter ? `${encodeURIComponent(delimiter)}` : ""}&hasHeader=${hasHeader}&filePath=${filePath}&fieldName=${fieldName}`;

export const getCheckRunAsAdminPremissionUrl = () => 'CheckRunAsAdminPremission'

export const setDataflowsLastUpdateUrl = () => 'SetLastUpdate';